var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { to } from "@lib/utils";
import { Network } from "@models/network";
import { Wallet } from "@models/wallet";
import * as Sentry from "@sentry/browser";
import bs58 from "bs58";
import nacl from "tweetnacl";
import { DeeplinkAction, signingMessage, WalletError, WalletExtension, } from "./utils";
const PHANTOM_DEEP_LINK_HOST = "https://phantom.app/ul/v1";
const PHANTOM_CLUSTER = "mainnet-beta";
export var PhantomRedirectAction;
(function (PhantomRedirectAction) {
    PhantomRedirectAction["PHANTOM_SIGN_IN"] = "phantom-sign-in";
    PhantomRedirectAction["PHANTOM_SIGN_MESSAGE"] = "phantom-sign-message";
    PhantomRedirectAction["PHANTOM_ADD_WALLET"] = "phantom-add-wallet";
})(PhantomRedirectAction || (PhantomRedirectAction = {}));
const encryptPayload = (payload, phantomPublicKey, secretKey) => {
    const sharedSecret = nacl.box.before(bs58.decode(phantomPublicKey), bs58.decode(secretKey));
    const nonce = nacl.randomBytes(24);
    const encryptedPayload = nacl.box.after(Buffer.from(JSON.stringify(payload)), nonce, sharedSecret);
    return { nonce: bs58.encode(nonce), payload: bs58.encode(encryptedPayload) };
};
const decryptPayload = (data, phantomPublicKey, secretKey, nonce) => {
    const sharedSecret = nacl.box.before(bs58.decode(phantomPublicKey), bs58.decode(secretKey));
    if (!sharedSecret)
        throw new Error("missing shared secret");
    const decryptedData = nacl.box.open.after(bs58.decode(data), bs58.decode(nonce), sharedSecret);
    if (!decryptedData) {
        throw new Error("Unable to decrypt data");
    }
    return JSON.parse(Buffer.from(decryptedData).toString("utf8"));
};
export const getConnectPhantomURL = (redirectUrl = "", add = false, authToken = "") => {
    try {
        const { publicKey: publicKeyArray, secretKey: secretKeyArray } = nacl.box.keyPair();
        const publicKey = bs58.encode(publicKeyArray);
        const secretKey = bs58.encode(secretKeyArray);
        const origin = redirectUrl || `${window.location.origin}${window.location.pathname}`;
        console.log("getConnectPhantomURL", origin);
        const redirect = `${origin}?action=${add
            ? PhantomRedirectAction.PHANTOM_ADD_WALLET
            : PhantomRedirectAction.PHANTOM_SIGN_IN}&k=${secretKey}&p=${publicKey}${authToken ? "&auth=" + authToken : ""}`;
        const params = new URLSearchParams({
            dapp_encryption_public_key: publicKey,
            cluster: PHANTOM_CLUSTER,
            app_url: encodeURI("https://app.moongate.id"),
            redirect_link: encodeURI(redirect),
        });
        const url = `${PHANTOM_DEEP_LINK_HOST}/connect?${params.toString()}`;
        // console.log("getConnectPhantomURL", url);
        return url;
    }
    catch (error) {
        console.log("getConnectPhantomURL", error);
        return "";
    }
};
export const verifyWalletPhantomMobile = (connectWalletResponse) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        // if (!connectWalletResponse || !connectWalletResponse.userId) return "";
        // console.log("verifyWalletPhantomMobile", connectWalletResponse);
        // const { walletAddress, session, secretKey, publicKey, phantomPublicKey } =
        //   connectWalletResponse;
        // if (
        //   !walletAddress ||
        //   !secretKey ||
        //   !session ||
        //   !publicKey ||
        //   !phantomPublicKey
        // )
        //   return "";
        // const message = bs58.encode(Buffer.from(signingMessage()));
        // const payload = {
        //   session,
        //   message,
        //   display: "utf8",
        // };
        // console.log("verifyWalletPhantomMobile", payload);
        // const deeplinkData: DeeplinkData = {
        //   userId: connectWalletResponse.userId,
        //   provider: WalletProvider.PHANTOM,
        //   action: DeeplinkAction.PHANTOM_SIGN_MESSAGE,
        //   secretKey,
        //   publicKey,
        //   phantomPublicKey,
        //   walletAddress,
        //   message,
        // };
        // // TODO Fix
        // // const token = await setDeeplinkData(deeplinkData);
        // // if (!token) return "";
        // const token = "";
        // const params = new URLSearchParams({
        //   ...{
        //     dapp_encryption_public_key: publicKey,
        //     redirect_link: encodeURI(
        //       `${window.location.origin}${window.location.pathname}?action=${DeeplinkAction.PHANTOM_SIGN_MESSAGE}&token=${token}`
        //     ),
        //   },
        //   ...encryptPayload(payload, phantomPublicKey, secretKey),
        // });
        // const url = `${PHANTOM_DEEP_LINK_HOST}/signMessage?${params.toString()}`;
        // console.log(url);
        // return url;
        return "";
    }
    catch (error) {
        console.log(error);
        return "";
    }
});
export const connectWalletPhantomMobileBrowser = (url) => {
    return `https://phantom.app/ul/browse/${encodeURIComponent(url)}?ref=${encodeURIComponent(window.location.hostname)}`;
};
export const handlePhantomRedirect = (queries) => __awaiter(void 0, void 0, void 0, function* () {
    console.log("handlePhantomRedirect", queries);
    if (!queries)
        return null;
    const action = queries["action"];
    const encryptedData = String(queries["data"]);
    const encodedNonce = String(queries["nonce"]);
    if (!action || !encryptedData || !encodedNonce)
        throw WalletError.UNKNOWN_ERROR;
    switch (action) {
        case PhantomRedirectAction.PHANTOM_SIGN_IN: {
            const phantomPublicKey = String(queries["phantom_encryption_public_key"]);
            const secretKey = String(queries["k"]);
            const publicKey = String(queries["p"]);
            if (!phantomPublicKey || !secretKey || !publicKey)
                throw WalletError.UNKNOWN_ERROR;
            const data = decryptPayload(encryptedData, phantomPublicKey, secretKey, encodedNonce);
            console.log(data);
            const { public_key, session } = data;
            if (!public_key || !session)
                throw WalletError.UNKNOWN_ERROR;
            console.log(public_key);
            return {
                action: PhantomRedirectAction.PHANTOM_SIGN_IN,
                data: {
                    wallet: public_key,
                    session,
                    phantomPublicKey,
                    secretKey,
                    publicKey,
                },
            };
        }
        case PhantomRedirectAction.PHANTOM_ADD_WALLET: {
            const phantomPublicKey = String(queries["phantom_encryption_public_key"]);
            const secretKey = String(queries["k"]);
            const publicKey = String(queries["p"]);
            if (!phantomPublicKey || !secretKey || !publicKey)
                throw WalletError.UNKNOWN_ERROR;
            const data = decryptPayload(encryptedData, phantomPublicKey, secretKey, encodedNonce);
            console.log(data);
            const { public_key, session } = data;
            if (!public_key || !session)
                throw WalletError.UNKNOWN_ERROR;
            console.log(public_key);
            return {
                action: PhantomRedirectAction.PHANTOM_ADD_WALLET,
                data: {
                    wallet: public_key,
                },
            };
        }
        case PhantomRedirectAction.PHANTOM_SIGN_MESSAGE: {
            const token = queries["token"];
            if (!token)
                throw WalletError.UNKNOWN_ERROR;
            // TODO Fix
            // const deeplinkData = await getDeeplinkData(token);
            // if (!deeplinkData) throw WalletError.UNKNOWN_ERROR;
            const deeplinkData = {};
            const { provider, action, secretKey, phantomPublicKey, walletAddress, message, } = deeplinkData;
            if (provider != WalletExtension.PHANTOM ||
                action != DeeplinkAction.PHANTOM_SIGN_MESSAGE)
                throw WalletError.UNKNOWN_ERROR;
            const data = decryptPayload(encryptedData, phantomPublicKey, secretKey, encodedNonce);
            console.log(data);
            const { signature } = data;
            if (!signature || !walletAddress || !message)
                throw WalletError.UNKNOWN_ERROR;
            console.log("handlePhantomRedirect", signature);
            const verified = nacl.sign.detached.verify(bs58.decode(message), bs58.decode(signature), bs58.decode(walletAddress));
            console.log(walletAddress, verified);
            if (!verified)
                throw WalletError.UNVERIFIED;
            // TODO fix
            // deleteDeeplinkData(token).catch((err) => console.log(err));
            return {
                action: PhantomRedirectAction.PHANTOM_SIGN_MESSAGE,
                data: {
                    wallet: walletAddress,
                },
            };
        }
    }
});
export const detectSolanaProvider = () => {
    if (window.solana && window.solana.isPhantom)
        return window.solana;
    throw WalletError.PHANTOM_NOT_INSTALLED;
};
export const connectWalletPhantom = () => __awaiter(void 0, void 0, void 0, function* () {
    Sentry.addBreadcrumb({
        category: "connectWalletPhantom",
        level: "info",
    });
    const provider = detectSolanaProvider();
    // console.log(provider);
    let err;
    let res;
    ({ err, res } = yield to(provider.connect()));
    // console.log(connectErr, resp);
    if (err || !(res === null || res === void 0 ? void 0 : res.publicKey)) {
        if ((err === null || err === void 0 ? void 0 : err.code) == 4001)
            throw WalletError.REQUEST_DENIED;
        throw WalletError.UNKNOWN_ERROR;
    }
    const walletAddress = res.publicKey.toString();
    return { walletAddress: walletAddress };
});
export const verifyWalletPhantom = (connectWalletResponse) => __awaiter(void 0, void 0, void 0, function* () {
    Sentry.addBreadcrumb({
        category: "verifyWalletPhantom",
        level: "info",
    });
    const provider = detectSolanaProvider();
    const { walletAddress: walletAddress } = connectWalletResponse;
    const message = signingMessage();
    const encodedMessage = new TextEncoder().encode(message);
    let err;
    let res;
    ({ err, res } = yield to(provider.signMessage(encodedMessage, "utf8")));
    if (err || !res) {
        if ((err === null || err === void 0 ? void 0 : err.code) == 4001)
            throw WalletError.REQUEST_DENIED;
        throw WalletError.UNKNOWN_ERROR;
    }
    const verified = nacl.sign.detached.verify(encodedMessage, res.signature, res.publicKey.toBytes());
    if (!verified)
        throw WalletError.UNVERIFIED;
    return new Wallet({
        network: Network.SOLANA,
        address: walletAddress,
        verified: true,
    });
});
